import { MsalAuthProvider, LoginType } from "react-aad-msal";
import { Logger, LogLevel } from "msal";

// B2C login
const tenant = process.env.REACT_APP_MSAL_TENANT;
const signInPolicy = process.env.REACT_APP_MSAL_SIGNIN_POLICY;
const applicationID = process.env.REACT_APP_MSAL_APP_ID;
const redirectURI = window.location.origin || process.env.REACT_APP_MSAL_REDIRECT_URI;

const tenantSubdomain = tenant.split(".")[0];
const instance = `https://${tenantSubdomain}.b2clogin.com/tfp/`;
const signInAuthority = `${instance}${tenant}/${signInPolicy}`;
const signInScopes = [
  process.env.REACT_APP_MSAL_SCOPES
];
// Allows to sign out on multiple Tabs in some browsers
const LOGGED_IN_KEY = `loggedIn`;
// Allows for One Provider only
let provider = null;


// Msal Configurations
const signInConfig = {
  auth: {
    authority: signInAuthority,
    clientId: applicationID,
    redirectUri: redirectURI,
    validateAuthority: false
  },
  system: {
    logger: new Logger(
      (logLevel, message, containsPii) => {
        console.log("[MSAL]", message);
      },
      {
        level: LogLevel.Verbose,
        piiLoggingEnabled: false
      }
    )
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true
  }
};
// Authentication Parameters
const authenticationParameters = {
  scopes: signInScopes
};
// Options
const options = {
  loginType: LoginType.Redirect,
  //tokenRefreshUri: window.location.origin + "/auth"
};

export const watchLoggedIn = event => {
  if (event.key === LOGGED_IN_KEY && provider && provider.authenticationState === "Authenticated") {
    provider.logout();
  }
};

export function initializeMsalProvider() {
  if (provider) {
    return provider;
  }
  // https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options
  provider = new MsalAuthProvider(
    signInConfig,
    authenticationParameters,
    options
    );
    localStorage.setItem(LOGGED_IN_KEY, true);
  return provider;
}

export function logout() {
  localStorage.removeItem(LOGGED_IN_KEY);
  provider.logout();
}

export function login() {
  provider.login();
}

export function signInAuthProvider () {
  const msalProvider = provider ?? initializeMsalProvider();
  return msalProvider;
}
